import { makeStyles } from '@mui/styles';
import scrollContainer from 'styles/scrollbar.styles';

export default makeStyles(() => ({
  scrollContainer,
  title: {
    fontSize: 20,
    fontStyle: 'italic',
    fontWeight: 'bold',
  },
}));
